module.exports = __webpack_public_path__ + "img/ibu-canggih-1.41808022.svg";